let prevArrow = `<button class="slick-prev slick-arrow"><svg height="50" width="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" xml:space="preserve">
<path fill="#333" d="M15.563 40.836a.997.997 0 0 0 1.414 0l15-15a1 1 0 0 0 0-1.414l-15-15a.999.999 0 1 0-1.414 1.414l14.293 14.293-14.293 14.293a1 1 0 0 0 0 1.414"/>
</svg></button>`;

let nextArrow = `<button class="slick-next slick-arrow"><svg height="50" width="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" xml:space="preserve">
<path fill="#333" d="M15.563 40.836a.997.997 0 0 0 1.414 0l15-15a1 1 0 0 0 0-1.414l-15-15a.999.999 0 1 0-1.414 1.414l14.293 14.293-14.293 14.293a1 1 0 0 0 0 1.414"/>
</svg></button>`;

document.addEventListener('DOMContentLoaded', () => {
    if($('.product-gallery .product-gallery--viewport')){
        $('.product-gallery .product-gallery--viewport').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            adaptiveHeight: true,
            asNavFor: '.product-gallery .product-gallery--navigation',
            responsive: [
                {
                  breakpoint: 990,
                  settings: {
                    arrows: false
                  }
                }
            ]
        });
    }
    
    if($('.product-gallery .product-gallery--navigation')){
        $('.product-gallery .product-gallery--navigation').slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            asNavFor: '.product-gallery .product-gallery--viewport',
            dots: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            // arrows: false,
            // centerMode: true,
            // centerPadding: '30px',
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                      arrows: false,
                      centerMode: true,
                      centerPadding: '20px',
                      slidesToShow: 6
                    }
                },
                {
                  breakpoint: 885,
                  settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '20px',
                    slidesToShow: 5
                  }
                },
                {
                  breakpoint: 440,
                  settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '20px',
                    slidesToShow: 4
                  }
                }
            ]
        });
    }
    
    $('.product-gallery').css('opacity', 1);
})